var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3022 2.49805C6.78741 2.49805 2.30078 6.98474 2.30078 12.4995C2.30078 18.0143 6.78741 22.5009 12.3022 22.5009C17.817 22.5009 22.3036 18.0143 22.3036 12.4995C22.3036 6.98474 17.817 2.49805 12.3022 2.49805ZM12.3022 20.6824C7.79004 20.6824 4.11922 17.0116 4.11922 12.4995C4.11922 7.98742 7.79004 4.31648 12.3022 4.31648C16.8143 4.31648 20.4852 7.98742 20.4852 12.4995C20.4852 17.0116 16.8143 20.6824 12.3022 20.6824Z",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3019 6.74023C11.6336 6.74023 11.0898 7.28431 11.0898 7.95307C11.0898 8.62123 11.6336 9.16482 12.3019 9.16482C12.9702 9.16482 13.5139 8.62123 13.5139 7.95307C13.5139 7.28431 12.9702 6.74023 12.3019 6.74023Z",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3037 10.9854C11.8016 10.9854 11.3945 11.3924 11.3945 11.8946V17.3499C11.3945 17.852 11.8016 18.2591 12.3037 18.2591C12.8059 18.2591 13.213 17.852 13.213 17.3499V11.8946C13.213 11.3924 12.8059 10.9854 12.3037 10.9854Z",
    fill: "#505050"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.eb4ae2bdc28e76a100cf1a4851dce6ab.svg";
export { ForwardRef as ReactComponent };